// Reemplaza este archivo con el módulo descargado desde /site-admin.
// Al estar versionado, Parcel lo incluye en GitHub Pages como fallback sin backend.
export const siteContentSnapshot = null;
